"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useIsGroupIndeterminate = void 0;
var _react = require("react");
var useIsGroupIndeterminate = exports.useIsGroupIndeterminate = function useIsGroupIndeterminate(_ref) {
  var selectedOptions = _ref.selectedOptions,
    filteredOptions = _ref.filteredOptions,
    groupBy = _ref.groupBy,
    getOptionValue = _ref.getOptionValue;
  return (0, _react.useCallback)(function (group) {
    var selectedIds = selectedOptions.map(getOptionValue);
    var groupOptions = filteredOptions.filter(function (opt) {
      return opt[groupBy] === group.groupKey;
    });
    var all = groupOptions.every(function (opt) {
      return selectedIds.includes(getOptionValue(opt));
    });
    var or = groupOptions.some(function (opt) {
      return selectedIds.includes(getOptionValue(opt));
    });
    return or && !all;
  }, [selectedOptions, filteredOptions]);
};